import { render, staticRenderFns } from "./GameClient.vue?vue&type=template&id=4e5f98e5&scoped=true&"
import script from "./GameClient.vue?vue&type=script&lang=js&"
export * from "./GameClient.vue?vue&type=script&lang=js&"
import style0 from "./GameClient.vue?vue&type=style&index=0&id=4e5f98e5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5f98e5",
  null
  
)

export default component.exports